import React, { useState, useEffect } from 'react'
import { FormGroup, ControlLabel, CheckPicker, Col, Row } from 'rsuite'
import { IconButton, Icon } from 'rsuite'
import { Table, Panel } from 'rsuite'
import { isRequired, isValidators, isRequiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { loadLocation } from '../../../components/location/Location'

const { Column, HeaderCell, Cell } = Table

export default function AdministrativeArea({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [location, setLocation] = useState()
  const [selectedData, setSelectedData] = useState([])
  const [selectedDataTableList, setSelectedDataTableList] = useState([])
  const [schema, setSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState(false)

  const [province, setProvince] = useState()
  const [district, setDistrict] = useState()
  const [subDistrict, setSubDistrict] = useState()
  const [selectedProvince, setSelectedProvince] = useState([])
  const [selectedDistrict, setSelectedDistrict] = useState([])
  const [selectedSubDistrict, setSelectedSubDistrict] = useState([])

  useEffect(() => {
    handleLocation()
  }, [])

  useEffect(() => {
    if (location) {
      let selectValue = [...schema.areaList.value]

      // console.log('selectValue : ', selectValue)

      if (selectValue.length > 0) {
        setValue(schema.areaList.name, selectValue)

        let provinceList = []
        let districtList = []
        let subDistrictList = []

        selectValue.forEach((item) => {
          let itemArray = item.split('-')

          if (itemArray.length > 0) {
            provinceList.push(itemArray[0])
          }

          if (itemArray.length > 1) {
            districtList.push(`${itemArray[0]}-${itemArray[1]}`)
          }

          if (itemArray.length > 2) {
            subDistrictList.push(item)
          }
        })

        provinceList = provinceList.filter((v, i, a) => a.indexOf(v) === i)
        districtList = districtList.filter((v, i, a) => a.indexOf(v) === i)
        subDistrictList = subDistrictList.filter((v, i, a) => a.indexOf(v) === i)

        // console.log('provinceList : ',provinceList,' , districtList : ',districtList,' , subDistrictList : ',subDistrictList)

        setSelectedProvince(provinceList)
        setSelectedDistrict(districtList)
        setSelectedSubDistrict(subDistrictList)

        onProvinceChange(provinceList, districtList, subDistrictList)
      } else {
        setValue(schema.areaList.name)
      }
    }
  }, [location])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await loadLocation()
    setLocation(location)
    setIsLoading(false)
  }

  const handleSelectChange = (provinceList, districtList, subDistrictList) => {
    // console.log('provinceList value : ', provinceList)
    // console.log('districtList value : ', districtList)
    // console.log('subDistrictList value : ', subDistrictList)

    let selectedDataList = [...subDistrictList]

    districtList?.forEach((item) => {
      let isContains = false

      for (let index = 0; index < subDistrictList.length; index++) {
        const element = subDistrictList[index]

        if (element.startsWith(item)) {
          isContains = true
          break
        }
      }

      if (!isContains) {
        selectedDataList.push(item)
      }
    })

    provinceList?.forEach((item) => {
      let isContains = false

      for (let index = 0; index < districtList.length; index++) {
        const element = districtList[index]

        if (element.startsWith(item)) {
          isContains = true
          break
        }
      }

      if (!isContains) {
        selectedDataList.push(item)
      }
    })

    selectedDataList.sort((a, b) => (a > b ? 1 : -1))

    if (selectedDataList.length === 0) {
      setValue(schema.areaList.name)
    } else {
      setValue(schema.areaList.name, selectedDataList)
    }
    setSelectedData(selectedDataList.length == 0 ? null : selectedDataList)
    generateTableSelectedData(selectedDataList)
  }

  const handleDelete = (value, index) => {
    // console.log('handleDelete value', value, 'index', index)

    let valueList = value.split('-')

    switch (valueList.length) {
      case 1:
        let provinceList = selectedProvince.filter((e) => e != value)
        onProvinceChange(provinceList, selectedDistrict, selectedSubDistrict)
        break
      case 2:
        if (selectedDistrict.filter((e) => e.startsWith(valueList[0]))?.length == 1) {
          let provinceList = selectedProvince.filter((e) => e != valueList[0])
          onProvinceChange(provinceList, selectedDistrict, selectedSubDistrict)
        } else {
          let districtList = selectedDistrict.filter((e) => e != value)
          onDistrictChange(districtList, selectedSubDistrict)
        }

        break
      case 3:
        let province = valueList[0]
        let district = `${valueList[0]}-${valueList[1]}`

        let condition1 = selectedDistrict.filter((e) => e.startsWith(province))?.length == 1
        let condition2 = selectedSubDistrict.filter((e) => e.startsWith(district))?.length == 1

        if (condition1 && condition2) {
          let provinceList = selectedProvince.filter((e) => e != province)
          onProvinceChange(provinceList, selectedDistrict, selectedSubDistrict)
        } else if (condition2) {
          let districtList = selectedDistrict.filter((e) => e != district)
          onDistrictChange(districtList, selectedSubDistrict)
        } else {
          let subDistrictList = selectedSubDistrict.filter((e) => e != value)
          setSelectedSubDistrict(subDistrictList)
          handleSelectChange(selectedProvince, selectedDistrict, subDistrictList)
        }

        break
      default:
        break
    }
  }

  const generateTableSelectedData = (selectedData) => {
    let selectDataTable = selectedData.map((val) => {
      let dataTable = { value: val }
      let valList = val.split('-')
      let dataObj = location
      let keyValue = ''

      for (let index = 0; index < valList.length; index++) {
        if (index === 0) {
          keyValue = valList[index]
        } else {
          keyValue += '-' + valList[index]
        }

        let obj
        dataObj?.forEach((item) => {
          if (item.value === keyValue) {
            obj = item
            return
          }
        })

        if (obj) {
          switch (index) {
            case 0:
              dataTable['province'] = obj.label
              break
            case 1:
              dataTable['district'] = obj.label
              break
            case 2:
              dataTable['subDistrict'] = obj.label
              break
            default:
              break
          }

          dataObj = obj.children
        }
      }

      !dataTable.district && (dataTable['district'] = 'ทุกอำเภอ')
      !dataTable.subDistrict && (dataTable['subDistrict'] = 'ทุกตำบล')
      return dataTable
    })

    //return (a, b) => a.label.localeCompare(b.label, 'th')
    selectDataTable.sort((a, b) => a.province.localeCompare(b.province, 'th'))

    setSelectedDataTableList(selectDataTable)
  }

  const onProvinceChange = (value, selectedDistrict, selectedSubDistrict) => {
    let selectedDistrictList = []
    let selectedSubDistrictList = []

    value.forEach((item) => {
      selectedDistrict.forEach((district) => {
        if (district.startsWith(item)) {
          selectedDistrictList.push(district)
        }
      })

      selectedSubDistrict.forEach((subDistrict) => {
        if (subDistrict.startsWith(item)) {
          selectedSubDistrictList.push(subDistrict)
        }
      })
    })

    let provinceList = location?.filter((e) => value.includes(e.value))
    // console.log('provinceList', provinceList)

    let districtList = []
    provinceList?.map((i) => {
      i.children?.map((e) => {
        let data = {
          id: e.id,
          role: i.label,
          label: e.label,
          value: e.value,
          subDistrict: e.children,
        }
        districtList.push(data)
      })
    })
    // console.log('selectedDistrictList : ', selectedDistrictList, ' , selectedSubDistrictList : ', selectedSubDistrictList )

    let selectDistrict = districtList.filter((e) => selectedDistrictList.includes(e.value))

    let subDistrictList = []
    selectDistrict.map((i) => {
      i.subDistrict.map((e) => {
        let data = {
          id: e.id,
          role: i.role + ' - ' + i.label,
          label: e.label,
          value: e.value,
        }
        subDistrictList.push(data)
      })
    })

    setSelectedProvince(value)
    setSelectedDistrict(selectedDistrictList)
    setSelectedSubDistrict(selectedSubDistrictList)
    setDistrict(districtList)
    setSubDistrict(subDistrictList)
    handleSelectChange(value, selectedDistrictList, selectedSubDistrictList)
  }

  const onDistrictChange = (value, selectedSubDistrict) => {
    let selectedSubDistrictList = []

    value.forEach((item) => {
      selectedSubDistrict?.forEach((subDistrict) => {
        if (subDistrict.startsWith(item)) {
          selectedSubDistrictList.push(subDistrict)
        }
      })
    })

    let districtList = district?.filter((e) => value.includes(e.value))
    // console.log('districtList', districtList)

    let subDistrictList = []
    districtList.map((i) => {
      i.subDistrict.map((e) => {
        let data = {
          id: e.id,
          role: i.role + ' - ' + i.label,
          label: e.label,
          value: e.value,
        }
        subDistrictList.push(data)
      })
    })
    // console.log('subDistrictList', subDistrictList)
    // setSelectedData(selectedList)
    setSelectedDistrict(value)
    setSelectedSubDistrict(selectedSubDistrictList)
    setSubDistrict(subDistrictList)
    handleSelectChange(selectedProvince, value, selectedSubDistrictList)
  }

  const addressInputForm = () => {
    return (
      <FormGroup>
        <ErrorMessage error={errors[schema.areaList.name]} />
        <ControlLabel>
          {isRequiredFiled(isRequired(schema.areaList.validators), schema.areaList.label)}
        </ControlLabel>
        <Controller
          key={schema.areaList.name}
          name={schema.areaList.name}
          control={control}
          rules={isValidators(schema.areaList.validators)}
          defaultValue={selectedData}
          value={selectedData}
        />
        <Row style={{ marginTop: 15 }}>
          <Col xs={24} sm={24} md={8} lg={8}>
            <ControlLabel>จังหวัด</ControlLabel>
            <CheckPicker
              data={location}
              sort={(isGroup) => {
                if (isGroup) {
                  return (a, b) => a.groupTitle.localeCompare(b.groupTitle, 'th')
                }

                return (a, b) => a.label.localeCompare(b.label, 'th')
              }}
              value={selectedProvince}
              placeholder={'เลือกจังหวัด'}
              style={{ width: '100%' }}
              onChange={(value) => {
                onProvinceChange(value, selectedDistrict, selectedSubDistrict)
              }}
            />
          </Col>

          <Col xs={24} sm={24} md={8} lg={8}>
            <ControlLabel>อำเภอ</ControlLabel>
            <CheckPicker
              data={district}
              groupBy="role"
              sort={(isGroup) => {
                if (isGroup) {
                  return (a, b) => a.groupTitle.localeCompare(b.groupTitle, 'th')
                }

                return (a, b) => a.label.localeCompare(b.label, 'th')
              }}
              value={selectedDistrict}
              placeholder={'เลือกอำเภอ'}
              style={{ width: '100%' }}
              onChange={(value) => {
                onDistrictChange(value, selectedSubDistrict)
              }}
            />
          </Col>

          <Col xs={24} sm={24} md={8} lg={8}>
            <ControlLabel>ตำบล</ControlLabel>
            <CheckPicker
              data={subDistrict}
              groupBy="role"
              sort={(isGroup) => {
                if (isGroup) {
                  return (a, b) => a.groupTitle.localeCompare(b.groupTitle, 'th')
                }

                return (a, b) => a.label.localeCompare(b.label, 'th')
              }}
              value={selectedSubDistrict}
              placeholder={'เลือกตำบล'}
              style={{ width: '100%' }}
              onChange={(value) => {
                setSelectedSubDistrict(value)
                handleSelectChange(selectedProvince, selectedDistrict, value)
              }}
            />
          </Col>
        </Row>
      </FormGroup>
    )
  }

  const tableShowSelected = () => {
    return (
      <div>
        <Table height={400} data={selectedDataTableList} wordWrap>
          <Column width={60} align="left">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell align="center">
              {(_, index) => {
                return <div>{index + 1}</div>
              }}
            </Cell>
          </Column>

          <Column minWidth={100} flexGrow={1}>
            <HeaderCell>จังหวัด</HeaderCell>
            <Cell dataKey="province" />
          </Column>

          <Column minWidth={100} flexGrow={1}>
            <HeaderCell>อำเภอ</HeaderCell>
            <Cell dataKey="district" />
          </Column>

          <Column minWidth={100} flexGrow={1}>
            <HeaderCell>ตำบล</HeaderCell>
            <Cell dataKey="subDistrict" />
          </Column>

          <Column width={100} fixed="right">
            <HeaderCell></HeaderCell>

            <Cell>
              {(rowData, index) => {
                return (
                  <div>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon className="bt-gost-icon-radius-cancel" icon="trash" />}
                      onClick={() => handleDelete(rowData.value, index)}
                      style={{ marginRight: 5 }}
                    >
                      ลบ
                    </IconButton>
                  </div>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </div>
    )
  }

  return (
    <div>
      <Panel style={{ marginTop: 10 }} bodyFill>
        <Panel header="" eventKey={1}>
          {addressInputForm()}
        </Panel>
        <Panel eventKey={2} bodyFill>
          {tableShowSelected()}
          <br />
        </Panel>
      </Panel>
      {isLoading && <OverlayLoader />}
    </div>
  )
}
